export default {
    'Number': 'NO.',
    'NoData': 'No result',
    'Cancel': 'Cancel',
    'OK': 'OK',
    'StartImport': 'Start to import',
    'ImportData': 'Import data',
    'ReImport': 'Import again',
    'Skip': 'Skip',
    'SureImport': 'Import',
    'ExportFailure': 'Export failed',
    'ExportLoading': 'Please wait while the build excel is in progress ...',
    'AllBeShown': 'Completed to load',
    'DeleteItems': 'Are you sure to delete the data？',
    'BizData': 'Non-workflow Data',
    'wlData1': 'Workflow data without influenced workflow',
    'wlData2': 'Parent process which related with child process',
    'wlData3': 'Child process Data',
    'DeleteItems1': '(It will delete related workflow Data after the data deleted.)',
    'DeleteItems2': '(The child process data will be deleted while its parent process data been deleted.)',
    'DeleteItems3': '(The instance data and its relationship with parent process will be deleted while the child process data been deleted.)',
    'NotAllowedDelete': 'Normal user cannot delete the workflow data',
    'NotDraftDelete': 'NotAllowedDelete',
    'BusinessRuleException': '[{propertyCode}] not exist which user in node name [{nodeName}] in business rules name [{businessRuleName}] on [{schemaName}] model,you can contact the administrator',
    'LogicCheckException': 'No validation data was found from target model name 【{targetSchemaName}】 in 【{nodeName}】',
    'Items': 'items',
    'NoPermissionAdd': 'You have not the permission to initiate the process',
    'NoPublish': 'Process has not been released',
    'NoPermissionDelete': 'You have not the permission',
    'DeleteItemsTips': '{successCount} items have been deleted，{errorCount} items faild with permission limited',
    'DeleteFailed': 'Delete failed',
    'DeleteLoading': 'Delete to load',
    'DeleteSuccess': 'Delete success',
    'Query': 'Search',
    'Add': 'Add',
    'Reset': 'Reset',
    'More': 'More',
    'TakeUp': 'Fold',
    'NoSearchResult': 'No resulet',
    'ContentLoadingFailed': 'Faild to load',
    'Refresh': 'Refresh',
    'Loading': 'Loading',
    'ImportTips1': 'For make sure the data is legal,please ',
    'ImportTips2': 'Download the sample file',
    'ImportTips3': 'Only support .xlsx file',
    'ImportTips4': 'Please do not close the windows otherwise it will be interrupted',
    'ImportTips5': 'System error,faild to import,please import again!',
    'ImportTips6': '{num} items have been imported successfully',
    'ImportTips7': '{num} items have been imported failed',
    'ImportTips8': 'Please import agin after revise',
    'ImportTips9': 'Limited to 500 lines to import,please revise and import again',
    'ImportTips10': 'The list title of the file is not compat with the list,please check',
    'ImportTips11': 'Only one file can be uploaded',
    'ImportWarn': 'Data import does not support import process data, please check carefully before importing!',
    'ImportLocalFaile': 'Upload the local file',
    'ClickToImport': 'Click or drag file to upload',
    'DownloadFailed': 'Download failed',
    'Importing': 'Importing',
    'ImportSuccess': 'Import successed',
    'ImportTestError': 'Parameter validation failed on reimport!',
    'ImportFailed': 'Import failed',
    'DownloadFailedList': 'Download the list',
    'SampleFile': 'Sample file',
    'Recheck': 'Check again',
    'ChooseQueryFiled': 'Select the query field',
    'ChooseQueryFiledTips': 'When importing, it queries the existing data according to the query field, overrides the import if it exists, and adds the import if it does not exist,supports only name, sequenceStatus, short text class data items.',
    'Total': 'Total {num} items',
    'Screen': 'Filter',
    'SetDisplayItems': 'Display items',
    'recovery': 'Restore default settings',
    'chooseColumns': 'Please setup the display items',
    'dragToSort': 'Sort by tap and hold-drag',
    'checkAll': 'Select All',
    'printQrcode': 'Print qrcode',
    'totalTip': 'Current total {total} items; please scan the qrcode to check whether the printed data is correct during preview',
    'chooseTagSize': 'Selection of Label Paper Size',
    'width': 'width',
    'height': 'height',
    'qrcodeText': 'Base Text of qrcode',
    'bizDataItem': 'bizModel dataitem',
    'sysDataItem': 'system dataitem',
    'textNumber': 'Bottom Text Number',
    'mostShowOne': 'Show up to one line of content',
    'example': 'Example',
    'qrcodeTextExample': 'Examples of bottom text of qrcode',
    'preview': 'preview',
    'print': 'Print preview',
    'pleaseSelect': 'Please select',
    'startExport': 'Start export',
    'exportData': 'Export data',
    'exportTips': 'The system will export checked field data',
    'loading': 'Please wait while the build is in progress ...',
    'importTitleTips': 'Please confirm the duplicate / empty data value of 【userName】',
    'chooseUser': 'Choose user',
    'chooseData': 'You have not select any data.',
    'chooseSheetData': 'You have not select any sheet data.',
    'null': 'null',
    'repeat': '(repeat)',
    'noExisted': '(noExisted)',
    'deptDisable': '(Department disabled)',
    'loadMore': 'loadMore',
    'loadCompleted': 'All data loaded',
    'modifyOwner': 'Modify owner',
    'selectOwner': 'Select owner',
    'ownerDepartment': 'Owner department',
    'modifyExplain': 'modify explain',
    'placeholder': 'Please',
    'pleaseSelectOwner': 'Please select owner',
    'ownerTip': 'There are {num} datas which you do not have permission to modify, their owners  in the datas you selected. The system will not modify the owner of these {num} datas.',
    'modifySuccess': 'Modify success',
    'printformTips': 'Your bid data has exceeded {size}, please delete some data or reprint in batches',
    'isCustomizePrintTemp': 'The current data does not have a custom print template set or the print template function is not enabled',
    'selectDataTips': 'There are {num} error drop-down boxes',
    'radioDataTips': 'There are {num} error radio buttons',
    'checkboxDataTips': 'There are {num} error checkboxes',
    'importDataTips': 'The fields of cannot match, please enter the same options',
    'gotIt': "Got it",
    'complete': "complete",
    'batchUpdata': 'Batch Edit',
    'addResult': 'Add result',
    'filterCondition': 'Filter condition',
    'importTitleBatchTips': 'Batch operation modify [selection control] content items',
    'all': "All"
};
